export default function WhyNairobiSection() {
  return (
    <section className="relative py-28 px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/site/nairobi001-1920x900.jpg"
          alt="Nairobi skyline"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0D1F14]/80" />
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-4">
            Strategic Location
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-white mb-5">
            Why Nairobi. Why Now.
          </h2>
          <p className="text-white/65 text-lg max-w-2xl mx-auto font-['Inter'] font-light leading-relaxed">
            Nairobi is East Africa&apos;s financial capital &mdash; a dynamic hub where diaspora capital, emerging markets, and global ambition converge.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              icon: "ri-global-line",
              title: "Regional Financial Hub",
              desc: "Nairobi hosts the Nairobi Securities Exchange, major international banks, and the headquarters of leading African financial institutions, making it the gateway to East African markets.",
            },
            {
              icon: "ri-bar-chart-grouped-line",
              title: "Fastest-Growing Markets",
              desc: "East Africa is among the world&apos;s fastest-growing economic regions. Kenya&apos;s GDP growth, expanding middle class, and tech-forward ecosystem create unparalleled investment opportunities.",
            },
            {
              icon: "ri-heart-line",
              title: "Diaspora Connection",
              desc: "With millions of Kenyans and East Africans living abroad, Nairobi is the natural anchor for diaspora-focused wealth creation, remittance investment, and cross-border financial planning.",
            },
          ].map((item) => (
            <div key={item.title} className="bg-white/10 backdrop-blur-sm rounded-lg p-8 border border-white/15">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#C9A961]/20 mb-6">
                <i className={`${item.icon} text-[#C9A961] text-2xl`} />
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-white mb-4">{item.title}</h3>
              <p
                className="text-white/65 text-sm leading-relaxed font-['Inter']"
                dangerouslySetInnerHTML={{ __html: item.desc }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
